/** Shared with the form so the regex is written once. */
export const USERNAME_PATTERN = /^[a-zA-Z0-9._-]+$/;
/** Letters, digits, hyphen, underscore, slash - covers CT-0042, EMP/007, 12345. */
export const EMPLOYEE_ID_PATTERN = /^[A-Za-z0-9/_-]+$/;
export const EMPLOYEE_ID_MAX = 32;
/** Practical shape check for the form; the API's Zod .email() is the control. */
export const EMAIL_PATTERN = /^\S+@\S+\.\S+$/;
export const EMAIL_MAX = 320;
export const USERNAME_MIN = 3;
export const USERNAME_MAX = 60;
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 72;
//# sourceMappingURL=users.js.map